export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6dc9ed9289197cfe3e54c627c568bb7a.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="flex items-center gap-16">
          <div className="flex-1">
            <div className="inline-block bg-teal-500/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <span className="text-teal-300 text-sm font-medium">// SECURE VPN</span>
            </div>
            
            <h1 className="text-6xl font-bold text-white mb-6 leading-tight">
              Protect Your<br />
              Digital<br />
              Privacy
            </h1>
            
            <p className="text-xl text-gray-200 mb-10 leading-relaxed max-w-xl">
              Experience ultimate online security with military-grade encryption. 
              Browse anonymously, access content freely, and keep your data safe 
              from prying eyes with STRADE VPN.
            </p>
            
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-teal-600 text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-teal-700 transition-all flex items-center gap-3 group whitespace-nowrap"
            >
              Download Now
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </button>
          </div>

          <div className="flex-1 hidden lg:block">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-teal-500/30 to-purple-500/30 rounded-3xl blur-3xl"></div>
              <div className="relative bg-gradient-to-br from-teal-500/10 to-purple-500/10 backdrop-blur-sm rounded-3xl p-8 border border-white/20">
                <img
                  src="https://readdy.ai/api/search-image?query=modern%20vpn%20application%20interface%20dashboard%20showing%20connection%20status%20with%20large%20connect%20button%20server%20selection%20map%20with%20location%20pins%20security%20indicators%20and%20encryption%20status%20clean%20minimal%20ui%20design%20in%20dark%20theme%20with%20teal%20and%20purple%20accent%20colors%20professional%20tech%20aesthetic&width=600&height=700&seq=vpn-dashboard-001&orientation=portrait"
                  alt="VPN Dashboard"
                  className="w-full h-auto rounded-2xl shadow-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
